import { createIcon } from '@chakra-ui/icons';

export const Upload = createIcon({
  displayName: 'Upload',
  viewBox: '0 0 24 21',
  d: 'M21.551 12.7041H24V20.051H0V12.7041H2.44898V17.602H21.551V12.7041ZM10.7755 4.69898L6.55102 8.92347L4.82143 7.17857L12 0L19.1786 7.17857L17.449 8.90816L13.2245 4.68367V14.6173H10.7755V4.69898Z',
});
